/**
 * KPI Constants
 *
 * This file contains constants used throughout the KPI feature.
 * Centralizing these values helps with maintenance and consistency.
 */

// Default frequency value for KPIs (in minutes)
export const DEFAULT_FREQUENCY_VALUE = '1'

// Maximum allowed lengths
export const MAX_KPI_NAME_LENGTH = 100
export const MAX_KPI_REMARK_LENGTH = 500
